import * as React from 'react'
import { OptionModel } from '../../home/models/OtherTypes';
import { Utils } from './Utils';

type OptionPickerProps = {
    options: OptionModel[];
    setOptions: (newOptions: OptionModel[]) => void;
    onChange: (status: any) => void;
    padding: number;
}

export default function OptionPicker({ options, setOptions, onChange, padding }: OptionPickerProps) {
    const onClick = (option: OptionModel) => {
        for (let i = 0; i < options.length; i++) {
            const current = options[i].key === option.key;
            options[i].current = current;
        }

        setOptions(options);
        onChange(option.key);
    }

    const optionElement = (option: OptionModel) => {
        return <div
            onClick={() => onClick(option)}
            className={"product-picker-wrapper option-picker pointer"}
            style={{ paddingLeft: padding, paddingRight: padding }}
        >
            {option.text}
            {!Utils.isNull(option.count) && option.count !== 0 &&
                <span className="count">
                    {option.count >= 10 ? "9+" : option.count.toString()}
                </span>}
            {option.current && <div className="color-selected mt-5"></div>}
        </div>;
    }

    return <div>{options.map(optionElement)}</div>;
}